import {
  Card,
  CardContent,
  Typography,
  Avatar,
  IconButton,
  useTheme,
} from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    position: 'relative',
  },
  avatar: {
    width: 60,
    height: 60,
    marginRight: theme.spacing(2),
  },
  content: {
    flex: 1,
    textAlign: 'center',
  },
  iconButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  name: {
    fontWeight: theme.typography.fontWeightBold,
  },
  subtitle: {
    color: Colors.TEXT_COLOR_SECONDARY,
    fontSize: '12px',
  },
  subtitleText: {
    color: Colors.TEXT_COLOR_TERTIARY,
    fontSize: '15px',
    fontWeight: 400,
  },
})

const UserCard = ({
  setOpenProfile,
}: {
  setOpenProfile: (e: boolean) => void
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <Avatar
        alt='Joel Mihavel'
        src='https://i.pravatar.cc/150?img=3' // Replace with actual image URL
        className={classes?.avatar}
      />
      <CardContent className={classes?.content}>
        <Typography variant='h6' className={classes?.name}>
          Joel Mihavel, <span className={classes?.subtitle}>49 Years old</span>
        </Typography>
        <Typography variant='body2' className={classes?.subtitleText}>
          -Father
        </Typography>
      </CardContent>
      <IconButton
        className={classes?.iconButton}
        onClick={() => setOpenProfile(true)}
      >
        <OpenInNewIcon />
      </IconButton>
    </Card>
  )
}

export default UserCard
